// packages/storefront/src/api/widgetSetupRefusal.ts
//
// The API's refusals of a widget's own setup — its business ID, its token or the page it runs on — told apart from
// a connection problem or a server fault. A widget shows such a refusal's reason (`WidgetErrorAlert`): only whoever
// set the widget up can fix it, so a "try again later" notice would never come true.

import type { ErrorCode } from '@tourtask/types/errorCodes';
import type { ResultError } from '@tourtask/types/result';

/** What `makeApiRoute` (apps/api/src/lib/http/makeApiRoute.ts) refuses a widget's setup with. */
const WIDGET_SETUP_REFUSAL_CODES: ReadonlySet<ErrorCode> = new Set<ErrorCode>([
	'BIZ.NOT_FOUND',
	'AUTH.MISSING_TOKEN',
	'AUTH.INVALID_TOKEN',
	'AUTH.TOKEN_BIZ_MISMATCH',
	'CORS.ORIGIN_NOT_ALLOWED',
]);

/** Whether the API refused the widget's setup (a wrong business ID or token, an unregistered page). */
export function isWidgetSetupRefusal(error: ResultError): boolean {
	return WIDGET_SETUP_REFUSAL_CODES.has(error.code);
}
